import { putApi } from '../api'

const baseUrl = '/api/internal/report/designer_transfers'

export function update(transferId, params) {
  return putApi(`${baseUrl}/${transferId}`, { ...params, format: 'json' })
}
